import { eventBus } from '@/bus';
import { getController, postController } from '@/controllers/request';
import { EVENTBUS_EVENTS, MODULE } from '@/utils/constants';
import { randomNumber, setContactData } from '@/utils/helpers';
import { errorMsg } from '@/utils/mixins';

const getDefaultParams = item => {
  let params = {
    open: {},
    save: {}
  };
  //Добавляем дефолтные параметры для открытия
  item.intents[0].url
    .split('?')[1]
    .split('&')
    .map(param => {
      if (param.split('=')[0] === 'action') {
        params.open.loadedAction = param.split('=')[1];
      }
      params.open[param.split('=')[0]] = param.split('=')[1];
    });
  // Добавляем дефолтные параметры для сохранения
  item.save
    .split('?')[1]
    .split('&')
    .map(param => {
      if (param.split('=')[0] === 'action')
        params.save.action = param.split('=')[1];
      params.save[param.split('=')[0]] = param.split('=')[1];
    });

  // Типы для скачивания файлов
  if (item.id === 'HRPAC_NEW_EPLOYEE_EXIT') params.open.type = 'employee-exit';
  if (item.id === 'HRPAC_OFFERS') params.open.type = 'offer';

  return params;
};

export default {
  namespaced: true,
  state: {
    tableData: {},
    tableFields: {},
    backgroundResumeLoading: false,
    requestSent: false,
    config: {},
    pageConfig: {},
    selected: [],
    customButtons: {}, //обособленные кнопки из метаданных
    mod: {},
    eventUsersId: [],
    callId: null,
    eventUsersEmails: [],
    visible_dialog: {
      confirm_close_dialog: {
        display: false,
        title: '',
        text: '',
        buttons: []
      },
      relation_dialog: false,
      detail: false,
      import_dialog: false,
      stage_dialog: { display: false, intents: [] },
      rejection_dialog: false,
      no_rejection_dialog: false,
      employee_exit_dialog: false,
      form_offer_dialog: false,
      send_mail_dialog: false,
      share_candidate_in_telegram_dialog: false,
      delete_dialog: false,
      merge_dublicate_dialog: false,
      delete_dublicate_dialog: false,
      security_dialog: false,
      add_contact_dialog: false,
      comment_dialog: false,
      selection_dialog: false,
      open_positions_dialog: false,
      cancel_positions_dialog: false,
      corporate_email_dialog: false,
      vacancies_popup: false,
      publicator_dialog: false,
      publicator_import_dialog: false,
      publicator_delete_dialog: false,
      publicator_auth_dialog: false,
      save_resume: false,
      preload_resume: false,
      mailings_conflict_dialog: false,
      publicator_refresh_dialog: false,
      scenario_dialog: true,
      admin_changes_dialog: false,
      admin_stages_dialog: false,
      candidate_import_dialog_single: false,
      candidate_import_dialog_multi: false,
      candidate_import_type_dialog: false,
      create_event_dialog_empty: false,
      create_event_dialog: false,
      application_dialog: false,
      questionnaire_dialog: false,
      training_dialog: false,
      event_view_dialog: false,
      confirm_remove_meeting_dialog: false,
      search_column_edit_dialog: false,
      mass_save_resume_dialog: false,
      mass_save_resume_progress_dialog: false,
      export_resume_to_xls_dialog: false,
      common_dialog: false,
      filters_dialog: false,
      sort_dialog: false,
      table_edit_dialog: false,
      general_dialog: { display: false, intents: [] },
      single_dialog: false,
      warning_sb_dialog: false,
      select_vacancy_for_call_dialog: false,
      telegram_popup: false,
      accept_import_dialog: { display: false, data: {} }
    },
    detachedEmailForm: {},
    detachedForm: {
      // данные по обособленным формам
      fields: {
        detail_experience: [],
        communications: [],
        education: [],
        skills_training: [],
        language_proficiency: [],
        language_level: [],
        another_work_place: [],
        sertificates: [],
        tests: [],
        recomendation: []
      },
      saveMode: false,
      validateStatus: {}
    },
    metaDialogLoaded: false, // проверка монтирования всех компонентов активного окна
    notifications: {},
    newOptions: {},
    clickSaveform: false,
    userId: null,
    generalStepsDialog: {
      loading: true,
      files: [],
      schema: {},
      steps: [],
      currentStep: {},
      stepKey: 0
    },
    saveFlag: false,
    service: null
  },
  mixins: [errorMsg],
  mutations: {
    setDetachedEmailForm(state, form) {
      state.detachedEmailForm = form;
    },
    setGeneralSchema(state, schema) {
      state.generalStepsDialog.schema = schema;
    },
    setRemoveGeneralDialog(state) {
      state.generalStepsDialog = {
        loading: true,
        schema: {},
        files: [],
        steps: [],
        currentStep: {},
        stepKey: 0
      };
    },
    setDialogValue(state, { name, value, id }) {
      if (id === state.generalStepsDialog.currentStep.id) {
        state.generalStepsDialog.currentStep[name] = value;
      }
      state.generalStepsDialog.steps.map(item => {
        if (item.id === id) {
          item[name] = value;
        } else {
          return item;
        }
      });
      state.generalStepsDialog.stepKey = randomNumber();
    },
    addEventUsersId(state, data) {
      state.eventUsersId = data;
    },

    addEventUsersEmails(state, data) {
      state.eventUsersEmails = data;
    },
    setGeneralSteps(state, steps) {
      if (!steps) return;

      state.generalStepsDialog.loading = true;
      state.generalStepsDialog.steps = steps.map(item => {
        return {
          ...item,
          id: item.id,
          skip: Number(item.skip),
          error: false,
          icon: item.icon,
          defaultParams: getDefaultParams(item),
          type: item.id === 'HRPAC_OFFERS' ? 'offer' : ''
        };
      });
      state.generalStepsDialog.currentStep =
        state.generalStepsDialog.steps.find(item => item.warning === true) ||
        state.generalStepsDialog.steps[0];
      state.generalStepsDialog.loading = false;
    },
    setClickSaveform(state, value) {
      state.clickSaveform = value;
    },
    setSaveFlag(state, value) {
      // отслеживание клика сейва для валидации радиокнопок
      state.saveFlag = value;
    },
    setNewCurrentStep(state, step) {
      state.generalStepsDialog.currentStep.loading = true;
      state.generalStepsDialog.currentStep = step;
      state.generalStepsDialog.stepKey = randomNumber();
    },
    setPolygraph(state, data) {
      state.generalStepsDialog.polygraphId = data;
    },
    setGeneralEmailsFiles(state, files) {
      state.generalStepsDialog.files = files;
    },
    setMod(state, obj) {
      state.mod = obj;
    },
    setIdData(state, id) {
      state.userId = id;
    },
    setBackgroundResumeLoading(state, val) {
      state.backgroundResumeLoading = val;
    },
    setNewOptions(state, val) {
      state.newOptions[val.name] = val.val;
    },
    setSelected(state, { replace = false, arr }) {
      if (replace) state.selected = arr;
      else state.selected.push(...arr);
    },
    setRequestState(state, val) {
      state.requestSent = val;
    },
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setConfig(state, data) {
      state.config = data;
    },
    setPageConfig(state, obj) {
      state.pageConfig = obj;
    },
    setVisibleDialog(state, { name, val, params = null }) {
      if (!val) state.metaDialogLoaded = false;
      if (name == 'confirm_close_dialog') {
        state.visible_dialog[name] = params
          ? {
              display: val,
              title: params.title,
              text: params.text,
              buttons: params.buttons || []
            }
          : { display: false };
      } else if (
        name == 'general_dialog' ||
        name == 'stage_dialog' ||
        name == 'warning_sb_dialog'
      ) {
        state.visible_dialog[name] = params
          ? Array.isArray(params) && params?.length
            ? {
                display: val,
                intents: params
              }
            : { display: val, data: params }
          : { display: false };
      } else {
        state.visible_dialog[name] = val;
      }
    },
    setDetachedFormFields(state, { fieldName, form }) {
      state.detachedForm.fields[fieldName] = form;
    },
    setDetachedFormMode(state, bool) {
      state.detachedForm.saveMode = bool;
    },
    setDetachedFormStatus(state, { name, valid }) {
      state.detachedForm.validateStatus[name] = valid;
    },
    addDetachFormField(state, { data, form }) {
      state.detachedForm.fields[form].splice(
        state.detachedForm.fields[form].length,
        0,
        data
      );
    },
    addContact(state, { opts = {}, index, value = '' }) {
      const defaultFirstOption = {
        type: Object.keys(opts)[0],
        lbl: Object.values(opts)[0]
      };
      const getRawPhoneNumber = phone => {
        if (!phone || typeof phone != 'string') return '';
        if (
          phone.slice(0, 3) !== '880' &&
          phone.slice(0, 1) === '8' &&
          phone.length > 2
        ) {
          // проверка на код Бангладеша и коды городов РФ, чтобы заменить +8 на +7
          const val = '7' + phone.slice(1);
          return val;
        } else return phone;
      };
      const isNumber = typeof index === 'number';
      const option = isNumber ? opts : defaultFirstOption;
      const { label, htmlType } = setContactData(option.type, null, option.lbl);
      const contact = {
        value_type: option.type,
        id: `${randomNumber()}`,
        label,
        htmlType,
        value:
          value && option.type == 'phone'
            ? getRawPhoneNumber(value)
            : value || ''
      };

      state.detachedForm.fields.communications.splice(
        isNumber ? index : state.detachedForm.fields.communications.length,
        0,
        contact
      );
    },
    setNotification(state, data = {}) {
      for (let key in data) {
        state.notifications[key] = data[key];
      }
    },
    setTableData(
      state,
      { module, columns, rows, replace = true, message = '' }
    ) {
      if (!module) return;

      const addElems = () => {
        state.tableData[module].rows.push(...rows);
        return state.tableData[module].rows;
      };

      if (replace) {
        state.tableData[module] = state.tableData[module]
          ? { ...state.tableData[module] }
          : {};

        state.tableData[module]['rows'] = rows ? rows : [];
        state.tableData[module]['message'] = message ? message : '';

        state.tableData[module]['columns'] = columns
          ? columns
          : { ...state.tableData[module]['columns'] } || {};
      } else {
        state.tableData = {
          ...state.tableData,
          [module]: {
            columns: columns
              ? columns
              : { ...state.tableData[module]['columns'] } || {},
            rows: !state.tableData[module].rows.length ? rows : addElems(),
            message: message ? message : ''
          }
        };
      }
    },
    getAddress({ commit }, address) {
      commit('addDetachFormField', {
        data: address,
        form: 'another_work_place'
      });
      return address;
    },
    sendOutcomingCall(state, { phone }) {
      if (!state.service) return;

      // Исходящий звонок в карточке кандидата
      state.service
        .click2Call({
          abonentNumber: phone,
          phoneNumber: phone,
          userId: state.userId
        })
        .then(() => {
          // В ответе придет объект, содержащий id созданного звонка
        });
    },
    notifyMe(state, { url, candidateName, icon, phone = '' }) {
      if (!('Notification' in window)) {
        alert('Браузер не поддерживает всплывающие уведомления');
      } else if (Notification.permission == 'denied') {
        alert(
          'Разрешите показ уведомлений для этого сайта в настройках браузера для корректного оповещения о входящих звонках'
        );
      } else if (Notification.permission === 'granted') {
        const notification = new Notification(
          `Входящий звонок на TalentForce
${candidateName || `Неизвестный кандидат ${phone}`}`,
          {
            icon: icon,
            requireInteraction: true, // появится кнопка Закрыть
            lang: 'RU'
            // badge:
            //   '/modules/Home/icons/logo/company_logo.svg'
          }
        );
        // notification.image = '/modules/Home/icons/logo/company_logo.svg'
        notification.addEventListener('click', function () {
          window.open(url, '_blank');
        });

        // …
      } else if (Notification.permission === 'default') {
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            const notification = new Notification(
              `входящий звонок на TalentForce
${candidateName || 'Неизвестный кандидат'}`,
              {
                icon: icon,
                requireInteraction: true, // появится кнопка Закрыть
                lang: 'RU'
                // badge:
                // '/modules/Home/icons/logo/company_logo.svg'
              }
            );
            // notification.image = '/modules/Home/icons/logo/company_logo.svg'
            notification.addEventListener('click', function () {
              window.open(url, '_blank');
            });
          }
        });
      }
    }
  },
  actions: {
    initTelephony({ state, dispatch, rootState }, baseUrl) {
      state.service = new window.TelephonyIntegration.IqtekIntegration({
        apiBaseURL:
          rootState.navbar.navigationData?.telephony_init?.apiBaseURL ||
          'https://tf.omctech.ru/api',
        wsURL:
          rootState.navbar.navigationData?.telephony_init?.wsURL ||
          'wss://tf.omctech.ru/ws',
        apiKey:
          rootState.navbar.navigationData?.telephony_init?.apiKey ||
          'rWairentyporICEntendiSTU',
        tfApiBaseURL: baseUrl || ''
      });

      state.service
        .connectWS()
        .then(() => {
          // событие о получении входящего звонка
          state.service.subscribe('CallReceivedEvent', payload => {
            // В нагрузке придет объект вида
            // {
            //   type: 'CallReceivedEvent',
            //   start_date: '2025-03-03T09:38:47+00:00',
            //   abonent: {
            //     user_id: '123',
            //     phone: '+79998887766',
            //  },
            //   phone_from: '+79998887755',
            // }

            if (payload.phone_from)
              dispatch('searchCandidate', payload.phone_from);
          });
        })
        .catch(error => {
          if (window.TelephonyIntegration) {
            // При неудачном подключении будет вызван обработчик ошибки
            // error содержит в себе сообщение о том, что пошло не так в процессе подключения
            if (
              window.TelephonyIntegration.LocalStorageError &&
              error instanceof window.TelephonyIntegration.LocalStorageError
            ) {
              // Если ошибка это экземпляр LocalStorageError, значит при подключении была проблема с доступом к localStorage
              console.warn(error.message);
            } else if (
              window.TelephonyIntegration.TFError &&
              error instanceof window.TelephonyIntegration.TFError
            ) {
              // Если ошибка это экземпляр TFError, значит при подключении была проблема с доступом к бэкенду TalentForce
              console.warn(error.message);
            } else {
              // В противном случае возникла иная ошибка, в том числе ошибка создания подключения
              console.warn(error);
            }
          } else console.warn(error);
        });
    },
    utilizeWS({ state }) {
      if (!state.service) return;
      state.service.unsubscribe('CallReceivedEvent');
      state.service.disposeWS().then(r => {
        if (r) {
          state.service = null;
        }
      });
    },
    async searchCandidate({ commit }, phone = '') {
      // когда входящий звонок, в браузерной вкладке отображается уведомление о звонящем
      try {
        const response = await getController({
          url: `/index.php?module=OMS_CALLS&action=get_candidate_edit_view_url_by_phone&phone=${phone}&to_pdf=1`
        });

        if (response?.data?.status == 'error') {
          errorMsg.methods.showNotification({
            showClose: true,
            message: response.data.error.error_text,
            type: 'error'
          });
          return;
        }

        const url = response.data.url || '';
        if (url === '' && !document.hidden) {
          commit('notifyMe', {
            ...response.data,
            url: location.origin + '/candidates',
            candidateName: response.data.name,
            phone
          });
        } else {
          const id = url.slice(url.indexOf('&record=') + '&record='.length);
          if (!id) return;
          if (!document.hidden) {
            commit('notifyMe', {
              ...response.data,
              url: location.origin + `/candidates/${id}`,
              candidateName: response.data.name,
              phone
            });
          }
        }
      } catch (error) {
        errorMsg.methods.showNotification({
          showClose: true,
          message:
            error?.response?.data?.error?.error_text ||
            'Возникла ошибка при поиске кандидата',
          type: 'error'
        });
      }
    },
    async getUserData({ commit }) {
      try {
        const request = await getController({
          params: {
            entryPoint: 'check_session_auth'
          }
        });

        commit('setIdData', request.data.details.user_id);
      } catch (err) {
        console.error(err);
      }
    },
    async saveGeneralForm({ state }) {
      let allStatus = [];
      try {
        for (
          let index = 0;
          index < state.generalStepsDialog.steps.length;
          index++
        ) {
          const item = state.generalStepsDialog.steps[index];
          if (item.required) {
            const options = new FormData();
            for (let key in item.form) {
              options.append(key, item.form[key]);
            }

            if (
              state.generalStepsDialog.files &&
              Array.isArray(state.generalStepsDialog.files) &&
              item.id == 'Emails'
            ) {
              state.generalStepsDialog.files.forEach(file => {
                const { raw: blob, name } = file;
                if (file.type == 'template' || file.type == 'forward') {
                  options.append('template_attachment[]', file.id);
                } else if (file.type == 'removed') {
                  options.append('temp_remove_attachment[]', file.id);
                } else {
                  options.append('email_attachment[]', blob, name);
                }
              });
            }

            for (let key in item.defaultParams.save) {
              options.append(key, item.defaultParams.save[key]);
            }

            if (state.eventUsersId?.length) {
              state.eventUsersId.forEach(id => {
                options.append('assigned_users_ids[]', id);
              });
            }

            if (state.eventUsersEmails?.length) {
              state.eventUsersEmails.forEach(email => {
                options.append('assigned_users_emails[]', email);
              });
            }

            const { data } = await postController({ options });

            if (data.status == 'error') {
              if (data.errors?.title) {
                errorMsg.methods.showNotification({
                  message: data.errors.title,
                  type: 'error',
                  position: 'center'
                });
              } else if (data.error?.error_text) {
                errorMsg.methods.showErrorMessage(
                  data.error.error_text == 'snils already in use'
                    ? 'Кандидат с таким СНИЛС уже существует в системе'
                    : 'Ошибка перевода на этап'
                );
                throw new Error(data.error.error_text);
              }
            }

            allStatus.push({ index, status: data?.status });
          }
        }

        const status = allStatus.map(item => item.status === 'ok');
        if (status.includes(false)) {
          return false;
        } else {
          return true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    fetchQuickSearch(
      { commit, rootState },
      { module, intents, filters, search, isAttachment = false }
    ) {
      const unpackedFilters = {};

      for (const key in filters) {
        unpackedFilters[key] = filters[key].value;
      }

      if (
        rootState.selectionPopup.popupPageConfig &&
        rootState.selectionPopup.popupPageConfig.main_search_field &&
        rootState.selectionPopup.popupPageConfig.main_search_field.length
      ) {
        for (
          let i = 0;
          i < rootState.selectionPopup.popupPageConfig.main_search_field.length;
          i++
        ) {
          unpackedFilters[
            rootState.selectionPopup.popupPageConfig.main_search_field[i].name
          ] = search;
        }
      }

      if (module == MODULE.VACANCY_MODULE && isAttachment) {
        intents.request_params.selected_ids =
          rootState.attachment.massAttachCandidates;
      }

      getController({
        url: intents.url,
        params: {
          ...intents.request_params,
          ...unpackedFilters,
          name_advanced: search
        }
      })
        .then(resp => {
          commit(
            'common/setTableData',
            {
              module:
                module == MODULE.CANDIDATE_RESPONDS
                  ? 'vacancy_responds'
                  : module,
              columns: resp?.data?.metadata
                ? resp?.data?.metadata?.data?.data?.title
                : resp?.data?.data?.data?.data?.title,
              rows: resp?.data?.metadata
                ? resp?.data?.metadata?.data?.data?.rows
                : resp?.data?.data?.data?.data?.rows
            },
            { root: true }
          );

          if (isAttachment) {
            commit(
              'attachment/setParam',
              {
                name: 'totalItemsToAttach',
                val: resp.data.data.pageData.offsets.total
              },
              { root: true }
            );
          }

          commit(
            'selectionPopup/setMetadataFields',
            resp?.data?.metadata
              ? resp?.data?.metadata?.sugarconfig
              : resp.data.sugarconfig,
            {
              root: true
            }
          );

          commit('setParam', {
            name: 'tableFields',
            val: resp?.data?.metadata
              ? resp?.data?.metadata?.sugarconfig
              : resp.data.sugarconfig
          });

          commit(
            'selectionPopup/popupPageConfig',
            resp?.data?.metadata
              ? resp?.data?.metadata?.pageData
              : resp?.data?.data?.pageData,
            {
              root: true
            }
          );

          commit(
            'filters/setFiltersConfig',
            resp?.data?.metadata
              ? resp?.data?.metadata?.custom_search
              : resp.data.custom_search,
            {
              root: true
            }
          );

          if (module == MODULE.CANDIDATES_MODULE)
            commit('candidate/setCandidateListData', resp.data, { root: true });

          if (module == MODULE.VACANCY_MODULE)
            commit('vacancy/setVacancyListData', resp.data, { root: true });

          if (module == MODULE.USERS) {
            commit(
              'users/setParam',
              { name: 'metadata', val: resp.data },
              { root: true }
            );
          }

          eventBus.$emit(EVENTBUS_EVENTS.UPDATE_TABLE);

          if (resp.data.data?.pageData?.queries?.baseURL?.name_advanced) {
            commit('filters/setFiltersActive', true, {
              root: true
            });
          }
        })
        .catch(err =>
          console.error('Ошибка при получении данных после фильтрации', err)
        );
    },
    applyFilters(
      { commit },
      {
        module,
        intents,
        filters,
        orderBy,
        sortOrder,
        saved_search_select,
        isAttachment = false
      }
    ) {
      const formData = new FormData();
      const unpackedFilters = {
        ...intents.request_params,
        ...filters,
        orderBy,
        sortOrder,
        saved_search_select
      };

      for (const key in unpackedFilters) {
        if (Array.isArray(unpackedFilters[key])) {
          for (const elem of unpackedFilters[key]) {
            formData.append(`${key}[]`, elem);
          }
        } else if (
          Object.prototype.toString
            .call(unpackedFilters[key])
            .includes('Object')
        ) {
          if (
            unpackedFilters[key].value != null &&
            unpackedFilters[key].value != ''
          )
            formData.append(key, unpackedFilters[key].value);
        } else if (unpackedFilters[key] != null && unpackedFilters[key] != '') {
          formData.append(key, unpackedFilters[key]);
        }
      }

      postController({
        url: intents.url,
        options: formData
      })
        .then(resp => {
          commit(
            'common/setTableData',
            {
              module:
                module == MODULE.CANDIDATE_RESPONDS
                  ? 'vacancy_responds'
                  : module,
              columns: resp?.data?.metadata
                ? resp?.data?.metadata?.data?.data?.title
                : resp?.data?.data?.data?.data?.title,
              rows: resp?.data?.metadata
                ? resp?.data?.metadata?.data?.data?.rows
                : resp?.data?.data?.data?.data?.rows
            },
            { root: true }
          );

          if (isAttachment) {
            commit(
              'attachment/setParam',
              {
                name: 'totalItemsToAttach',
                val: resp.data.data.pageData.offsets.total
              },
              { root: true }
            );
          }

          commit(
            'selectionPopup/setMetadataFields',
            resp?.data?.metadata
              ? resp?.data?.metadata?.sugarconfig
              : resp.data.sugarconfig,
            {
              root: true
            }
          );

          commit('setParam', {
            name: 'tableFields',
            val: resp?.data?.metadata
              ? resp?.data?.metadata?.sugarconfig
              : resp.data.sugarconfig
          });

          commit(
            'selectionPopup/popupPageConfig',
            resp?.data?.metadata
              ? resp?.data?.metadata?.pageData
              : resp.data.data.pageData,
            {
              root: true
            }
          );

          commit(
            'filters/setFiltersConfig',
            resp?.data?.metadata
              ? resp?.data?.metadata?.custom_search
              : resp.data.custom_search,
            {
              root: true
            }
          );

          //если фильтруем вкладку отклики или кандидаты
          //то кешируем полученные данные
          if (
            module == 'vacancy_candidates' ||
            module == MODULE.CANDIDATE_RESPONDS
          ) {
            commit(
              'subpanels/setFiltersData',
              {
                module:
                  module == 'vacancy_candidates' ? 'candidates' : 'responds',
                data: resp?.data?.metadata
                  ? resp?.data?.metadata?.custom_search
                  : resp.data.custom_search
              },
              {
                root: true
              }
            );
          }
          //если применили сортировку, то обновляем метаданные вкладки
          if (module == 'vacancy_candidates') {
            commit(
              'subpanels/setActiveSubpanelData',
              {
                tabName: 'candidates',
                data: resp?.data?.panels || resp?.data
              },
              {
                root: true
              }
            );
            eventBus.$emit(EVENTBUS_EVENTS.UPDATE_KEY, 'buttonsUpdateKey');
          }

          if (module == MODULE.HRPAC_CANDIDATES_DUPLICATES) {
            commit(
              'dublicates/setParam',
              { name: 'metadata', val: resp.data },
              {
                root: true
              }
            );
          }
          if (module == MODULE.CANDIDATES_MODULE)
            commit('candidate/setCandidateListData', resp.data, {
              root: true
            });

          if (module == MODULE.VACANCY_MODULE && !isAttachment) {
            commit('vacancy/setVacancyListData', resp.data, { root: true });
          } else if (module == MODULE.USERS) {
            commit(
              'users/setParam',
              {
                name: 'metadata',
                val: resp.data
              },
              { root: true }
            );
          } else {
            commit(
              'attachment/setParam',
              {
                name: 'metadata',
                val: resp.data
              },
              { root: true }
            );
          }

          eventBus.$emit(EVENTBUS_EVENTS.UPDATE_TABLE);

          if (resp.data.data?.pageData?.queries?.baseURL?.name_advanced) {
            commit('filters/setFiltersActive', true, {
              root: true
            });
          }
        })
        .catch(err =>
          console.error('Ошибка при получении данных после фильтрации', err)
        );
    },
    catchError(ctx, { err, msg, action }) {
      console.error(action + ' error.', err);

      errorMsg.methods.showNotification({
        offset: 100,
        showClose: true,
        duration: 25000,
        message: msg,
        type: 'error'
      });
    },
    successMessage(ctx, { msg }) {
      errorMsg.methods.showNotification({
        offset: 100,
        showClose: true,
        duration: 25000,
        message: msg,
        type: 'success'
      });
    },
    getAddExperience({ commit }) {
      const experience = {
        id: randomNumber(),
        sort: null,
        fields: [
          {
            name: 'company_name',
            value: ''
          },
          {
            name: 'period_begin',
            value: ''
          },
          {
            name: 'period_end',
            value: ''
          },
          {
            name: 'checkbox_job_now',
            value: true
          },
          {
            name: 'post',
            value: ''
          },
          {
            name: 'post_desc',
            value: ''
          },
          {
            name: 'period_length',
            value: ''
          }
        ]
      };

      commit('addDetachFormField', {
        data: experience,
        form: 'detail_experience'
      });
      return experience;
    },
    getAddEducation({ commit }) {
      const education = {
        id: randomNumber(),
        sort: null,
        fields: [
          {
            name: 'university',
            value: ''
          },
          {
            name: 'specialization',
            value: ''
          },
          {
            name: 'year_of_graduation',
            value: ''
          },
          {
            name: 'education_lvl',
            value: ''
          }
        ]
      };

      commit('addDetachFormField', { data: education, form: 'education' });
      return education;
    },
    getAddLanguage({ commit }) {
      const language = {
        id: randomNumber(),
        sort: null,
        fields: [
          {
            name: 'language_proficiency',
            value: ''
          },
          {
            name: 'language_proficiency_lvl',
            value: ''
          }
        ]
      };

      commit('addDetachFormField', {
        data: language,
        form: 'language_proficiency'
      });
      return language;
    },
    getAddLanguageLevel({ commit }, language) {
      commit('addDetachFormField', {
        data: language,
        form: 'language_level'
      });
      return language;
    },
    getAddress({ commit }, address) {
      commit('addDetachFormField', {
        data: address,
        form: 'another_work_place'
      });
      return address;
    },
    getAddQualification({ commit }) {
      const qualification = {
        id: randomNumber(),
        sort: null,
        fields: [
          {
            name: 'organization',
            value: ''
          },
          {
            name: 'course_name',
            value: ''
          },
          {
            name: 'year_of_graduation',
            value: ''
          }
        ]
      };

      commit('addDetachFormField', {
        data: qualification,
        form: 'skills_training'
      });
      return qualification;
    },
    getAddRecomendation({ commit }) {
      const recomendation = {
        id: randomNumber(),
        sort: null,
        fields: [
          {
            name: 'name',
            value: ''
          },
          {
            name: 'position',
            value: ''
          },
          {
            name: 'organization',
            value: ''
          }
        ]
      };

      commit('addDetachFormField', {
        data: recomendation,
        form: 'recomendation'
      });
      return recomendation;
    },
    async saveForm(context, { options }) {
      try {
        return await postController({
          options,
          params: {
            header: {
              'Content-Type': 'multipart/form-data'
            }
          }
        });
      } catch (e) {
        console.error(e);
      }
    },
    async sendRequest(context, { params }) {
      try {
        return await getController({ params });
      } catch (e) {
        console.error(e);
      }
    },
    async sendPostRequest(context, { params, form }) {
      let formData = new FormData();
      const defaultParams = { ...params };

      for (let key in form) {
        if (Array.isArray(form[key])) {
          if (!form[key].length) {
            defaultParams[`${key}[]`] = '';
          } else {
            defaultParams[key] = form[key];
          }
        } else {
          formData.set(key, form[key] || '');
        }
      }
      try {
        return await postController({
          params: defaultParams,
          options: formData
        });
      } catch (e) {
        console.error(e);
      }
    },
    async getSteps(
      { commit },
      {
        candidate_id,
        selection_stage_actions,
        vacancy_id = '',
        selection_stage_id = ''
      }
    ) {
      try {
        const params = {
          action: 'checkActionsBeforeChangeStage',
          module: 'HRPAC_SELECTION_STAGE',
          selection_stage_actions: JSON.stringify(selection_stage_actions),
          candidate_id,
          vacancy_id,
          selection_stage_id,
          jsqon_return: 1,
          to_pdf: true
        };
        const { data } = await getController({ params });
        commit('setGeneralSteps', data);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
